/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberProfileDimensionModel } from '../../models/member-profile-dimension-model';

export interface ConsumerDimensionGet$Params {
}

export function consumerDimensionGet(http: HttpClient, rootUrl: string, params?: ConsumerDimensionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberProfileDimensionModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerDimensionGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MemberProfileDimensionModel>>;
    })
  );
}

consumerDimensionGet.PATH = '/Consumer/Dimension';
